import { styled as t, Box as a } from "@mui/material";
import { SkeletonTypography as l } from "../generic/Skeleton.js";
import { noForwardProps as n } from "../../../util/styled/index.js";
import m from "react-middle-ellipsis";
import { jsx as o } from "react/jsx-runtime";
const c = t(l, n)`
  display: inline;
  white-space: ${({
  __whitespaceWrap: r
}) => r ? "normal" : "nowrap"};
`, x = (r) => {
  const {
    children: p,
    className: i,
    loading: e,
    whitespaceWrap: s
  } = r;
  return /* @__PURE__ */ o(a, {
    className: i,
    children: /* @__PURE__ */ o(m, {
      children: /* @__PURE__ */ o(c, {
        className: i,
        loading: e,
        __whitespaceWrap: s,
        children: p
      })
    })
  });
};
export {
  x as default
};
//# sourceMappingURL=ApeironEllipsisTypography.js.map
